export default __webpack_public_path__ + "static/media/bazaar-logo.ff7bfa3c.svg";